export default {
  barley: {
    0: 1.0,
    15: 2.0,
    16: 3.0,
    17: 4.0,
    18: 4.8,
    19: 5.5,
    20: 6.5,
    21: 7.5,
    22: 8.5,
    23: 10,
  },
  wheat: {
    0: 1.0,
    15: 2.0,
    16: 3.0,
    17: 4.0,
    18: 4.8,
    19: 5.5,
    20: 6.5,
    21: 7.5,
    22: 8.5,
    23: 10,
  },
  beans: {
    0: 5.0,
    15: 5.5,
    16: 6.0,
    17: 6.5,
    18: 7.0,
    19: 7.5,
    20: 8.3,
    21: 9.5,
    22: 10.5,
    23: 11.5,
    24: 13.0,
  },
};
